import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import { SpaceModelUnit, SpaceRentPrice, SpaceAmenities } from "./space-form-inputs";
import { PeekAddressInput } from "@piiqtechnologies/ui-components";
export const SpaceSettingsFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        unit: yup.string().required(intl.formatMessage(messages.updateFormUnitNumberRequired)),
        bedrooms: yup.number().min(0, intl.formatMessage(messages.updateFormNumberOfBedroomsInvalid)),
        bathrooms: yup.number().min(0, intl.formatMessage(messages.updateFormNumberOfBathroomsInvalid)),
        unitSize: yup.number().min(0, intl.formatMessage(messages.updateFormUnitSizeInvalid)),
        displayPrice: yup
            .number()
            .typeError(intl.formatMessage(messages.updateFormRentFormat))
            .nullable(true)
            .transform((_value, originalValue) => typeof originalValue === "string" ? Number(originalValue.replace(/,/g, "")) : originalValue)
            .min(0, intl.formatMessage(messages.updateFormRentFormat))
            .max(99999, intl.formatMessage(messages.updateFormRentInvalid)),
    });
};
export const SpaceSettingsFormInitialValue = {
    building: {
        address: "",
    },
    unit: "",
    isModelUnit: false,
    bedrooms: 0,
    bathrooms: 0,
    unitSize: 0,
    description: "",
    floorPlan: {
        name: "",
    },
    amenities: [],
    displayPrice: 0,
};
export const getSpaceSettingsFormFields = (space) => {
    const intl = useIntl();
    return {
        address: [
            {
                id: "building.address",
                label: intl.formatMessage(messages.updateFormSpaceAddress),
                placeholder: intl.formatMessage(messages.updateFormSpaceAddress),
                required: true,
                component: PeekAddressInput,
                columns: 12,
            },
        ],
        unitAndIsModelUnit: [
            {
                id: "unit",
                label: intl.formatMessage(messages.updateFormUnitNumber),
                placeholder: intl.formatMessage(messages.updateFormUnitNumber),
                required: true,
                columns: 4,
            },
            {
                id: "isModelUnit",
                label: intl.formatMessage(messages.updateFormIsModelUnit),
                placeholder: intl.formatMessage(messages.updateFormIsModelUnit),
                required: false,
                component: SpaceModelUnit,
                type: "checkbox",
                style: { paddingTop: "1.5rem" },
            },
        ],
        bedroomAndBathroomAndLayoutType: [
            {
                id: "bedrooms",
                label: intl.formatMessage(messages.updateFormNumberOfBedrooms),
                placeholder: intl.formatMessage(messages.updateFormNumberOfBedrooms),
                required: false,
                type: "number",
                columns: 4,
            },
            {
                id: "bathrooms",
                label: intl.formatMessage(messages.updateFormNumberOfBathrooms),
                placeholder: intl.formatMessage(messages.updateFormNumberOfBathrooms),
                required: false,
                type: "number",
                columns: 4,
            },
            {
                id: "floorPlan.name",
                label: intl.formatMessage(messages.updateFormLayoutType),
                placeholder: intl.formatMessage(messages.updateFormLayoutType),
                required: false,
                columns: 4,
            },
        ],
        rentAndUnitSize: [
            {
                id: "displayPrice",
                label: intl.formatMessage(messages.updateFormRent),
                placeholder: "0,00",
                required: false,
                component: SpaceRentPrice,
                columns: 4,
                // @ts-ignore
                enabled: !space.dxUpdate ||
                    !space.community.displayPriceField ||
                    space.community.displayPriceField === "rentPrices.12.price",
            },
            {
                id: "unitSize",
                label: intl.formatMessage(messages.updateFormUnitSize),
                placeholder: intl.formatMessage(messages.updateFormUnitSize),
                required: false,
                type: "number",
                columns: 4,
            },
        ],
        description: [
            {
                id: "description",
                label: intl.formatMessage(messages.updateFormLabel),
                placeholder: intl.formatMessage(messages.updateFormDescription),
                required: false,
                multiline: true,
                rows: 6,
                columns: 12,
                fullWidth: true,
            },
        ],
        amenities: [
            {
                id: "amenities",
                label: intl.formatMessage(messages.updateFormAmenities),
                required: false,
                placeholder: "",
                columns: 12,
                component: SpaceAmenities,
            },
        ],
    };
};
